<mat-card class="card-style-full px-6 py-6 pt-0">
  <mat-card-header class="flex justify-between items-center">
    <mat-card-title class=""
      >Cadastro Conteúdo - Sugestão</mat-card-title
    >
    <button class="btn-icon" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </mat-card-header>

  <div [formGroup]="form" class="mt-8 mb-0">
    <div>
      <div class="flex justify-between gap-4 items-center">
        <mat-form-field class="input-tg w-4/12" appearance="outline">
          <mat-label>Título</mat-label>
          <input matInput formControlName="title" />
        </mat-form-field>
        <mat-form-field class="input-tg w-4/12" appearance="outline">
          <mat-label>Subtítulo</mat-label>
          <input matInput formControlName="subtitle"/>
        </mat-form-field>
        <mat-form-field class="input-tg w-4/12" appearance="outline">
          <mat-label>Tipo de Conteúdo - Sugestão</mat-label>
          <mat-select formControlName="contentType">
            @for (item of listUseTypes; track item) {
              <mat-option [value]="item.id">{{ item.descricao}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <div class="flex justify-between gap-4 items-center">
        <mat-form-field class="input-tg w-full" appearance="outline">
          <mat-label>Descrição</mat-label>
          <textarea matInput formControlName="description"></textarea>
        </mat-form-field>
      </div>
    </div>
    <div class="flex justify-end mt-3">
      <button
        mat-flat-button
        class="btn-tg w-1/5"
        [disabled]="!this.form.valid || loading"
        (click)="createLocation()"
      >
        @if (loading) {
          <mat-spinner diameter="22" class="loading-spinner"></mat-spinner>
        } @else {
          Cadastrar
        }
      </button>
    </div>
  </div>
</mat-card>
